import { Platform, StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    button: {
        width: Platform.select({
            default: widthPercentageToDP(328, 170),
            web: 146,
        }),
    },
    buttonText: {
        color: COLOR.background,
    },
    playerNotificationContainer: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 2,
    },
});

export default styles;
